import { render, staticRenderFns } from "./VerifyEmailSendSuccessPage.vue?vue&type=template&id=530fc3c4&"
import script from "./VerifyEmailSendSuccessPage.vue?vue&type=script&lang=js&"
export * from "./VerifyEmailSendSuccessPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports